export default __webpack_public_path__ + "static/media/ckad.cc531b66.svg";